export default "__VITE_ASSET__DDxNSgh$__"